<app-tutorial *ngIf="config?.showTutorial" tutorialUrl="https://www.youtube.com/embed/dL-SFriLT3I" title="Netbanking Autopay Tutorial"
              text="How autopay via Netbanking works?" eventName="how_autopay_nb_works">
</app-tutorial>

<div class="payment-sip-net-banking">
  <form [formGroup]="bankForm">
    <mat-form-field>
      <mat-select [formControl]="bankForm?.get('bankCode')" [placeholder]="info.bank.placeholder" (openedChange)="resetSearch()">
        <app-input class="search-input" inputType="text" [control]="bankForm?.get('searchBank')" [group]="bankForm" placeHolder="Search"
                    (OnChange)="search($event)">
        </app-input>
        <mat-option *ngFor="let item of (config?.paymentOptions?.options?.Emandate || config?.paymentOptions?.options?.NB) | keyvalue" [value]="item.key" class="bankDropdownList">
          {{item.value}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <app-input *ngIf="config?.paymentOptions?.options?.Emandate" inputType="tel"
              [control]="bankForm?.get('accountNo')"
              [group]="bankForm"
              [placeHolder]="info.accountNo.placeholder"
              [errorMessage]="info.accountNo.error">
    </app-input>
    <app-input *ngIf="config?.paymentOptions?.options?.Emandate" inputType="text"
              [control]="bankForm?.get('ifsc')"
              [group]="bankForm"
              [placeHolder]="info.ifsc.placeholder"
              [errorMessage]="info.ifsc.error">
    </app-input>
  </form>
</div>